export default __webpack_public_path__ + "static/media/shop_hot_3.5d7b5fb0.png";